/**
 * Données versionnées de la liste des dossiers (referentiel-metier.md §1.6) : libellés des statuts du contrat
 * (`DossierStatus`) et de l'ordre du filtre. Libellés à valider par le cabinet ; jamais dans la logique.
 */
export const REFERENTIEL_LISTE = {
  version: '2026-10-26',
  statuts: [
    { code: 'prospect', libelle: 'Prospect' },
    { code: 'actif', libelle: 'Actif' },
    { code: 'bloque', libelle: 'Bloqué' },
    { code: 'clos', libelle: 'Clos' },
    { code: 'abandonne', libelle: 'Abandonné' },
  ] as readonly { code: string; libelle: string }[],
} as const;

export const libelleStatutDossier = (code: string): string =>
  REFERENTIEL_LISTE.statuts.find((s) => s.code === code)?.libelle ?? 'Statut à qualifier';
